module.exports = __webpack_public_path__ + "static/media/orbit-seasons-2.png";